export default "{\n    \"viewJob\": \"VER TRABAJO\"\n}\n"